import { routes } from '../../router'
import { ContractCategoryStatus } from '../Categories/types'

export const CONTRACT_CATEGORY_DETAILS_BREADCRUMBS = (
  contractCategoryName: string,
  userCanSeeMyContracts: boolean
) => {
  const contractsRoute = {
    children: 'Contracts',
    href: routes.contracts
  }

  const myContractsRoute = {
    children: 'My Contracts',
    href: `${routes.contracts}${routes.myContracts}`
  }

  const currentRoute = {
    children: contractCategoryName
  }

  return userCanSeeMyContracts
    ? [contractsRoute, myContractsRoute, currentRoute]
    : [contractsRoute, currentRoute]
}

export const CATEGORY_STATUS_TO_LABEL = {
  [ContractCategoryStatus.ACTIVE]: 'Contract(s) for category end in',
  [ContractCategoryStatus.CONTRACTING]: 'Category contracts start',
  [ContractCategoryStatus.EXPIRED]: 'Ended on',
  [ContractCategoryStatus.CREATED]: 'Set up on',
  [ContractCategoryStatus.RFP]: 'Bidding started on',
  [ContractCategoryStatus.LOADING]: 'Set up on'
} as const
